module.exports = __webpack_public_path__ + "static/media/mh.3410f02f.svg";